export class ComparisonCardModel {
  plan1: string;
  plan2: string;
  summary: Array<any>;
  details: Array<any>;
}
